import React, { Component } from 'react'
import { connect } from 'react-redux'
import { firestoreConnect } from 'react-redux-firebase'
import { compose } from 'redux'
import styled from 'styled-components'
import MapList from './MapList'

const ClearNavbarContainer = styled.div`
  margin-left: 230px;
  height: 100vh;
  background: #0063c0;
  @media only screen and (max-width: 700px) {
    margin-left: 0;
  }
`

class Dashboard extends Component {
  render() {
    const { maps } = this.props;
    return (
      <ClearNavbarContainer>
            <MapList maps={maps} />
      </ClearNavbarContainer>
    ) 
  }
}

const mapStateToProps = (state) => {
  return {
    maps: state.firestore.ordered.maps
  }
}

export default compose(
  connect(mapStateToProps),
  firestoreConnect([
    { collection: 'maps', orderBy: ['createdAt', 'desc']}
  ])
)(Dashboard)



// WEBPACK FOOTER //
// ./src/components/maps/Dashboard.js